import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertTriangle, ShieldCheck, ArrowRight, Music, BookOpen, TrendingDown, Clock, Star, Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const FadeIn = ({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.6,
  delay
}} data-id="element-14">
    {children}
  </motion.div>;
function PricingSection() {
  const [selected, setSelected] = useState<'base' | 'combo' | 'blues' | 'completo'>('base');
  const options = {
    base: {
      name: 'MEGA KIT DOCENTE BASE',
      emoji: '📦',
      subtitle: '6 Tomos + 5 Bonos',
      oldPrice: '$289.000',
      price: '$19.990',
      link: 'https://guitarracashout.ebookditales.com/cart/52234689806623:1',
      ctaText: 'SÍ, QUIERO EL MEGA KIT GUITARRA COMPLETA →',
      includes: ['Tomo 1: Semillero Argentino (Kids)', 'Tomo 2: Fogón Nacional (Acústica Adultos)', 'Tomo 3: Eléctrica Rock & Blues', 'Tomo 4: Nuestra Tierra (Folklore)', 'Tomo 5: Esquina Tango & Milonga', 'Tomo 6: Laboratorio Moderno']
    },
    combo: {
      name: 'MEGA KIT + PASIÓN FLAMENCA',
      emoji: '🏆',
      subtitle: '6 Tomos + Pasión Flamenca + 5 Bonos',
      oldPrice: '$338.000',
      price: '$22.990',
      link: 'https://guitarracashout.ebookditales.com/cart/52237008470303:1',
      ctaText: 'SÍ, QUIERO EL MEGA KIT + PASIÓN FLAMENCA →',
      includes: ['Tomo 1: Semillero Argentino (Kids)', 'Tomo 2: Fogón Nacional (Acústica Adultos)', 'Tomo 3: Eléctrica Rock & Blues', 'Tomo 4: Nuestra Tierra (Folklore)', 'Tomo 5: Esquina Tango & Milonga', 'Tomo 6: Laboratorio Moderno', 'Pasión Flamenca — 5 Módulos + 40 canciones']
    },
    blues: {
      name: 'MEGA KIT + BLUES JAZZ Y SOUL',
      emoji: '🎷',
      subtitle: '6 Tomos + Blues Jazz & Soul + 5 Bonos',
      oldPrice: '$358.000',
      price: '$24.990',
      link: 'https://guitarracashout.ebookditales.com/cart/52237348471071:1',
      ctaText: 'SÍ, QUIERO EL MEGA KIT + BLUES JAZZ Y SOUL →',
      includes: ['Tomo 1: Semillero Argentino (Kids)', 'Tomo 2: Fogón Nacional (Acústica Adultos)', 'Tomo 3: Eléctrica Rock & Blues', 'Tomo 4: Nuestra Tierra (Folklore)', 'Tomo 5: Esquina Tango & Milonga', 'Tomo 6: Laboratorio Moderno', 'Kit Blues, Jazz & Soul — 40 canciones en 3 niveles']
    },
    completo: {
      name: 'MEGA KIT COMPLETO',
      emoji: '💎',
      subtitle: '6 Tomos + Pasión Flamenca + Blues Jazz & Soul + 5 Bonos',
      oldPrice: '$427.000',
      price: '$29.990',
      link: 'https://guitarracashout.ebookditales.com/cart/52237350306079:1',
      ctaText: 'SÍ, QUIERO EL MEGA KIT COMPLETO →',
      includes: ['Tomo 1: Semillero Argentino (Kids)', 'Tomo 2: Fogón Nacional (Acústica Adultos)', 'Tomo 3: Eléctrica Rock & Blues', 'Tomo 4: Nuestra Tierra (Folklore)', 'Tomo 5: Esquina Tango & Milonga', 'Tomo 6: Laboratorio Moderno', 'Pasión Flamenca — 5 Módulos + 40 canciones', 'Kit Blues, Jazz & Soul — 40 canciones en 3 niveles']
    }
  };
  const current = options[selected];
  return <section id="compra" className="bg-stone-900 scroll-mt-0" data-id="element-15">
      {/* ABOVE THE FOLD — fits iPhone screen */}
      <div className="px-4 py-12 md:py-20" data-id="element-16">
        <div className="max-w-3xl mx-auto w-full" data-id="element-17">
          <div className="text-center mb-6 md:mb-12" data-id="element-18">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-2 md:mb-4" data-id="element-19">
              ELEGÍ TU <span className="text-amber-400" data-id="element-20">MEGA KIT:</span>
            </h2>
            <p className="text-base md:text-lg text-stone-400" data-id="element-21">
              Todas las opciones incluyen los 5 bonos para docentes.
            </p>
          </div>

          <div className="space-y-3 md:space-y-4 mb-6 md:mb-8" data-id="element-22">
            {/* Option 1: Base */}
            <button onClick={() => setSelected('base')} className={`w-full text-left rounded-2xl p-4 md:p-6 flex items-center gap-3 md:gap-4 transition-all duration-200 cursor-pointer border-2 ${selected === 'base' ? 'bg-stone-800 border-amber-400 shadow-[0_0_20px_rgba(245,158,11,0.15)]' : 'bg-stone-800/50 border-stone-700 hover:border-stone-600'}`} data-id="element-23">
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'base' ? 'border-amber-400 bg-amber-400' : 'border-stone-500'}`} data-id="element-24">
                {selected === 'base' && <div className="w-2.5 h-2.5 rounded-full bg-stone-900" data-id="element-25" />}
              </div>
              <div className="flex-grow min-w-0" data-id="element-26">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-27">
                  <span className="text-lg" data-id="element-28">📦</span>
                  <h3 className="text-base md:text-xl font-black text-white" data-id="element-29">
                    MEGA KIT DOCENTE BASE
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-stone-400" data-id="element-30">
                  6 Tomos + 5 Bonos
                </p>
                <p className="text-[10px] md:text-xs text-stone-500 mt-0.5 leading-snug" data-id="element-31">
                  Un año de clases listas: Kids, Acústica, Eléctrica, Folklore,
                  Tango y Moderno.
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-32">
                <p className="text-stone-500 line-through text-xs md:text-sm font-bold" data-id="element-33">
                  $289.000
                </p>
                <p className={`text-xl md:text-3xl font-black ${selected === 'base' ? 'text-amber-400' : 'text-white'}`} data-id="element-34">
                  $19.990
                </p>
              </div>
            </button>

            {/* Option 2: Combo (MÁS ELEGIDO) */}
            <button onClick={() => setSelected('combo')} className={`w-full text-left rounded-2xl p-4 md:p-6 flex items-center gap-3 md:gap-4 transition-all duration-200 cursor-pointer border-2 relative ${selected === 'combo' ? 'bg-stone-800 border-amber-400 shadow-[0_0_20px_rgba(245,158,11,0.15)]' : 'bg-stone-800/50 border-stone-700 hover:border-stone-600'}`} data-id="element-35">
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'combo' ? 'border-amber-400 bg-amber-400' : 'border-stone-500'}`} data-id="element-36">
                {selected === 'combo' && <div className="w-2.5 h-2.5 rounded-full bg-stone-900" data-id="element-37" />}
              </div>
              <div className="flex-grow min-w-0" data-id="element-38">
                <div className="flex items-center gap-2 mb-0.5 flex-wrap" data-id="element-39">
                  <span className="text-lg" data-id="element-40">🏆</span>
                  <h3 className="text-base md:text-xl font-black text-white" data-id="element-41">
                    MEGA KIT + PASIÓN FLAMENCA
                  </h3>
                </div>
                <div className="flex items-center gap-2 mb-0.5" data-id="element-42">
                  <span className="bg-amber-500 text-stone-900 text-[10px] md:text-xs font-black px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-43">
                    ⭐ MÁS ELEGIDO
                  </span>
                </div>
                <p className="text-xs md:text-sm text-stone-400" data-id="element-44">
                  6 Tomos + Pasión Flamenca + 5 Bonos
                </p>
                <p className="text-[10px] md:text-xs text-stone-500 mt-0.5 leading-snug" data-id="element-45">
                  Todo el Kit Base + 5 módulos de guitarra española, 40
                  canciones flamencas y técnicas paso a paso.
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-46">
                <p className="text-stone-500 line-through text-xs md:text-sm font-bold" data-id="element-47">
                  $338.000
                </p>
                <p className={`text-xl md:text-3xl font-black ${selected === 'combo' ? 'text-amber-400' : 'text-white'}`} data-id="element-48">
                  $22.990
                </p>
              </div>
            </button>

            {/* Option 3: Blues Jazz y Soul */}
            <button onClick={() => setSelected('blues')} className={`w-full text-left rounded-2xl p-4 md:p-6 flex items-center gap-3 md:gap-4 transition-all duration-200 cursor-pointer border-2 relative ${selected === 'blues' ? 'bg-stone-800 border-amber-400 shadow-[0_0_20px_rgba(245,158,11,0.15)]' : 'bg-stone-800/50 border-stone-700 hover:border-stone-600'}`} data-id="element-49">
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'blues' ? 'border-amber-400 bg-amber-400' : 'border-stone-500'}`} data-id="element-50">
                {selected === 'blues' && <div className="w-2.5 h-2.5 rounded-full bg-stone-900" data-id="element-51" />}
              </div>
              <div className="flex-grow min-w-0" data-id="element-52">
                <div className="flex items-center gap-2 mb-0.5 flex-wrap" data-id="element-53">
                  <span className="text-lg" data-id="element-54">🎷</span>
                  <h3 className="text-base md:text-xl font-black text-white" data-id="element-55">
                    MEGA KIT + BLUES JAZZ Y SOUL
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-stone-400" data-id="element-56">
                  6 Tomos + Blues Jazz & Soul + 5 Bonos
                </p>
                <p className="text-[10px] md:text-xs text-stone-500 mt-0.5 leading-snug" data-id="element-57">
                  Todo el Kit Base + 40 canciones de blues, jazz y soul en 3
                  niveles. Acordes gourmet, licks y escala de blues.
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-58">
                <p className="text-stone-500 line-through text-xs md:text-sm font-bold" data-id="element-59">
                  $358.000
                </p>
                <p className={`text-xl md:text-3xl font-black ${selected === 'blues' ? 'text-amber-400' : 'text-white'}`} data-id="element-60">
                  $24.990
                </p>
              </div>
            </button>

            {/* Option 4: Mega Kit Completo */}
            <button onClick={() => setSelected('completo')} className={`w-full text-left rounded-2xl p-4 md:p-6 flex items-center gap-3 md:gap-4 transition-all duration-200 cursor-pointer border-2 relative ${selected === 'completo' ? 'bg-stone-800 border-amber-400 shadow-[0_0_20px_rgba(245,158,11,0.15)]' : 'bg-stone-800/50 border-stone-700 hover:border-stone-600'}`} data-id="element-61">
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'completo' ? 'border-amber-400 bg-amber-400' : 'border-stone-500'}`} data-id="element-62">
                {selected === 'completo' && <div className="w-2.5 h-2.5 rounded-full bg-stone-900" data-id="element-63" />}
              </div>
              <div className="flex-grow min-w-0" data-id="element-64">
                <div className="flex items-center gap-2 mb-0.5 flex-wrap" data-id="element-65">
                  <span className="text-lg" data-id="element-66">💎</span>
                  <h3 className="text-base md:text-xl font-black text-white" data-id="element-67">
                    MEGA KIT COMPLETO
                  </h3>
                </div>
                <div className="flex items-center gap-2 mb-0.5" data-id="element-68">
                  <span className="bg-green-600 text-white text-[10px] md:text-xs font-black px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-69">
                    💎 TODO INCLUIDO
                  </span>
                </div>
                <p className="text-xs md:text-sm text-stone-400" data-id="element-70">
                  6 Tomos + Pasión Flamenca + Blues Jazz & Soul + 5 Bonos
                </p>
                <p className="text-[10px] md:text-xs text-stone-500 mt-0.5 leading-snug" data-id="element-71">
                  El Mega Kit Docente Base + Pasión Flamenca + Blues Jazz y
                  Soul. Todo el material completo en un solo pack.
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-72">
                <p className="text-stone-500 line-through text-xs md:text-sm font-bold" data-id="element-73">
                  $427.000
                </p>
                <p className={`text-xl md:text-3xl font-black ${selected === 'completo' ? 'text-amber-400' : 'text-white'}`} data-id="element-74">
                  $29.990
                </p>
              </div>
            </button>
          </div>

          {/* CTA Button */}
          <a href={current.link} target="_blank" rel="noopener noreferrer" className="block w-full bg-green-600 hover:bg-green-500 text-white text-lg md:text-xl font-black py-4 md:py-5 px-6 rounded-2xl shadow-[0_0_40px_rgba(22,163,74,0.4)] hover:shadow-[0_0_60px_rgba(22,163,74,0.6)] transition-all transform hover:-translate-y-1 animate-pulse-glow text-center mb-3" data-id="element-75">
            {current.ctaText}
          </a>
          <p className="text-center text-stone-500 text-sm mb-6" data-id="element-76">
            Podés pagar con tarjeta, transferencia o Mercado Pago.
          </p>

          {/* What's included */}
          <div className="bg-stone-800 rounded-2xl p-5 md:p-8 border border-stone-700" data-id="element-77">
            <p className="font-black text-white mb-5 uppercase tracking-wider text-sm" data-id="element-78">
              {current.name} INCLUYE:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6" data-id="element-79">
              {current.includes.map((item, i) => <div key={i} className="flex items-start gap-2 text-sm text-stone-300 font-medium" data-id="element-80">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-81" />
                  <span data-id="element-82">{item}</span>
                </div>)}
            </div>
            <div className="border-t border-stone-700 pt-5" data-id="element-83">
              <p className="font-black text-amber-400 mb-3 uppercase tracking-wider text-xs" data-id="element-84">
                + 5 BONOS INCLUIDOS:
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4" data-id="element-85">
                {['Sistema de Retención de Alumnos', 'Planificador Anual del Docente', 'Método Anti-Abandono para Adultos', 'Kit de Contenido para Instagram'].map((item, i) => <div key={i} className="flex items-start gap-2 text-sm text-stone-300 font-medium" data-id="element-86">
                    <Gift className="w-5 h-5 text-amber-500 flex-shrink-0" data-id="element-87" />
                    <span data-id="element-88">{item}</span>
                  </div>)}
              </div>
              <div className="flex items-start gap-2 text-sm text-red-400 font-bold bg-red-950/50 p-3 rounded-lg border border-red-900/50" data-id="element-89">
                <AlertTriangle className="w-5 h-5 flex-shrink-0" data-id="element-90" />
                <span data-id="element-91">Guía de Precios y Negocio (Solo primeros 50)</span>
              </div>
            </div>
          </div>

          {/* Trust badges */}
          <div className="mt-6 flex flex-wrap justify-center gap-4 md:gap-8 text-stone-400 text-sm font-medium pb-4" data-id="element-92">
            <span className="flex items-center gap-1.5" data-id="element-93">
              <CheckCircle2 className="w-4 h-4 text-green-400" data-id="element-94" /> Pago único
            </span>
            <span className="flex items-center gap-1.5" data-id="element-95">
              <CheckCircle2 className="w-4 h-4 text-green-400" data-id="element-96" /> Acceso
              inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-97">
              <CheckCircle2 className="w-4 h-4 text-green-400" data-id="element-98" /> Descarga
              ilimitada
            </span>
            <span className="flex items-center gap-1.5" data-id="element-99">
              <CheckCircle2 className="w-4 h-4 text-green-400" data-id="element-100" /> Sin
              suscripciones
            </span>
          </div>
        </div>
      </div>
    </section>;
}
export function SalesPage() {
  const scrollToCompra = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-stone-50 font-sans selection:bg-amber-200 selection:text-stone-900" data-id="element-101">
      {/* HERO SECTION */}
      <section className="bg-stone-900 text-stone-100 relative overflow-hidden" data-id="element-102">
        {/* Subtle background pattern/glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-amber-900/20 blur-[120px] rounded-full pointer-events-none" data-id="element-103" />

        {/* ABOVE THE FOLD — fits iPhone 16 screen */}
        <div className="min-h-[100dvh] flex flex-col justify-center px-4 pt-6 pb-4 md:pt-12 md:pb-12 relative z-10" data-id="element-104">
          <div className="max-w-5xl mx-auto text-center w-full" data-id="element-105">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5
          }} data-id="element-106">
              <h1 className="text-[2rem] leading-[1.15] md:text-6xl lg:text-7xl font-black text-white mb-3 md:mb-6 md:leading-tight" data-id="element-107">
                MEGA KIT GUITARRA COMPLETA <br data-id="element-108" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600" data-id="element-109">
                  — EDICIÓN DOCENTE
                </span>
              </h1>

              <div className="w-20 md:w-24 h-1 bg-amber-500 mx-auto mb-3 md:mb-8 rounded-full" data-id="element-110" />

              <p className="text-lg md:text-2xl text-stone-300 font-medium max-w-3xl mx-auto mb-2 md:mb-4 leading-snug md:leading-relaxed" data-id="element-111">
                Para profesores de guitarra que sienten que trabajan mucho… pero
                siguen agotados, improvisando y con alumnos que no paran de
                abandonar.
              </p>
              <p className="text-base md:text-xl text-amber-400 font-bold max-w-3xl mx-auto mb-4 md:mb-10" data-id="element-112">
                Cuando toda tu energía se va en preparar clases… tu negocio no
                puede crecer.
              </p>
            </motion.div>

            <a href="#compra" onClick={scrollToCompra} className="block max-w-[260px] md:max-w-xl mx-auto cursor-pointer group relative mb-4 md:mb-10" data-id="element-113">
              <div className="absolute inset-0 bg-amber-500/15 blur-3xl rounded-full group-hover:bg-amber-500/25 transition-colors" data-id="element-114" />
              <img src="https://cdn.magicpatterns.com/uploads/m9zmYAPKnBKNSC6JQz4xii/heylloyd-image-1773098710691-removebg-preview.png" alt="Mega Kit Guitarra Completa — Pack Exclusivo Profesores de Guitarra" className="w-full h-auto relative z-10 transform group-hover:scale-[1.02] transition-transform duration-300 drop-shadow-2xl" data-id="element-115" />
            </a>

            <button onClick={scrollToCompra} className="w-full md:w-auto bg-green-600 hover:bg-green-500 text-white text-lg md:text-2xl font-black py-3.5 md:py-5 px-8 md:px-10 rounded-full shadow-[0_0_40px_rgba(22,163,74,0.4)] hover:shadow-[0_0_60px_rgba(22,163,74,0.6)] transition-all transform hover:-translate-y-1 animate-pulse-glow flex items-center justify-center gap-3 mx-auto max-w-sm md:max-w-none" data-id="element-116">
              SÍ, QUIERO EL MEGA KIT GUITARRA COMPLETA{' '}
              <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-117" />
            </button>
          </div>
        </div>

        {/* BELOW THE FOLD — seamless dark continuation */}
        <div className="max-w-5xl mx-auto text-center px-4 pb-20 relative z-10" data-id="element-118">
          <FadeIn delay={0.2} data-id="element-119">
            <p className="text-stone-400 max-w-2xl mx-auto mb-10" data-id="element-120">
              Este sistema te da un año entero de clases de guitarra argentina
              listas para usar con orden, con sistema y sin improvisar nunca
              más.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-121">
            <div className="bg-stone-800/50 border border-stone-700 rounded-2xl p-6 md:p-8 max-w-2xl mx-auto mb-12 backdrop-blur-sm" data-id="element-122">
              <h3 className="text-2xl font-bold text-white mb-6" data-id="element-123">
                MEGA KIT GUITARRA COMPLETA — EDICIÓN DOCENTE
              </h3>
              <ul className="text-left space-y-3 mb-8" data-id="element-124">
                {['6 Tomos completos', '178 canciones argentinas con tablatura', '52 semanas de clases diseñadas', 'Sistema de retención de alumnos', 'Planificador anual del negocio', 'Kit de contenido para Instagram', 'Guía de precios y negocio 2024'].map((item, i) => <li key={i} className="flex items-start gap-3 text-stone-300" data-id="element-125">
                    <CheckCircle2 className="w-6 h-6 text-amber-500 flex-shrink-0" data-id="element-126" />
                    <span className="font-medium" data-id="element-127">{item}</span>
                  </li>)}
              </ul>
              <p className="text-2xl font-black text-white mb-6" data-id="element-128">
                👉 Acceso inmediato por $19.990
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* PAIN POINTS SECTION */}
      <section className="py-20 px-4 bg-white" data-id="element-129">
        <div className="max-w-4xl mx-auto" data-id="element-130">
          <FadeIn data-id="element-131">
            <h2 className="text-3xl md:text-5xl font-black text-stone-900 mb-8 text-center leading-tight" data-id="element-132">
              Si sos profesor de guitarra, probablemente esto te pasa…
            </h2>
            <div className="prose prose-lg prose-stone mx-auto mb-16 text-stone-600 text-center md:text-left" data-id="element-133">
              <p data-id="element-134">Terminás una clase. Respirás. Mirás el reloj.</p>
              <p data-id="element-135">Y te das cuenta de algo.</p>
              <p data-id="element-136">
                Tenés otro alumno en una hora y todavía no sabés bien qué vas a
                dar.
              </p>
              <p data-id="element-137">Entonces empieza lo de siempre.</p>
              <p data-id="element-138">
                Abrís YouTube. Buscás una tablatura. Adaptás algo rápido. Y
                arrancás la clase con esa sensación incómoda de:
              </p>
              <p className="italic font-medium text-stone-800 text-xl" data-id="element-139">
                "Espero que esto alcance."
              </p>
              <p data-id="element-140">El problema no es tu capacidad como músico ni como docente.</p>
              <p className="font-bold text-stone-900" data-id="element-141">
                El problema es que estás sosteniendo todo sin un sistema que te
                sostenga a vos.
              </p>
              <p data-id="element-142">
                Y eso termina generando tres cosas que desgastan a la mayoría de
                los profesores de guitarra:
              </p>
            </div>
          </FadeIn>

          <div className="space-y-8" data-id="element-143">
            <FadeIn delay={0.1} data-id="element-144">
              <div className="bg-amber-50 border border-amber-200 rounded-2xl p-8 shadow-sm relative overflow-hidden" data-id="element-145">
                <div className="absolute top-0 right-0 w-32 h-32 bg-amber-200/50 rounded-bl-full -z-0" data-id="element-146" />
                <h3 className="text-2xl font-black text-stone-900 mb-4 relative z-10 flex items-center gap-3" data-id="element-147">
                  <span className="bg-amber-500 text-white w-10 h-10 rounded-full flex items-center justify-center text-xl" data-id="element-148">
                    1
                  </span>
                  Preparás demasiado y cobrás demasiado poco
                </h3>
                <p className="text-stone-700 mb-4 relative z-10" data-id="element-149">
                  Cada clase que das tiene detrás una hora de preparación que no
                  le cobrás a nadie. Buscás la tablatura. La adaptás al nivel.
                  Pensás qué ejercicio técnico viene. Buscás la canción que
                  pidió la semana pasada.
                </p>
                <div className="bg-white p-4 rounded-lg border border-amber-100 relative z-10" data-id="element-150">
                  <p className="text-stone-800 font-medium" data-id="element-151">
                    Si cobrás $8.000 la hora de clase y perdés 3 horas semanales
                    preparando material, estás regalando{' '}
                    <span className="text-red-600 font-bold" data-id="element-152">
                      $96.000 por mes
                    </span>
                    . Más de{' '}
                    <span className="text-red-600 font-bold" data-id="element-153">
                      $1.000.000 por año
                    </span>
                    . En tiempo que podrías estar cobrando.
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-154">
              <div className="bg-stone-50 border border-stone-200 rounded-2xl p-8 shadow-sm relative overflow-hidden" data-id="element-155">
                <div className="absolute top-0 right-0 w-32 h-32 bg-stone-200/50 rounded-bl-full -z-0" data-id="element-156" />
                <h3 className="text-2xl font-black text-stone-900 mb-4 relative z-10 flex items-center gap-3" data-id="element-157">
                  <span className="bg-stone-800 text-white w-10 h-10 rounded-full flex items-center justify-center text-xl" data-id="element-158">
                    2
                  </span>
                  Tus alumnos abandonan y no sabés por qué
                </h3>
                <p className="text-stone-700 mb-4 relative z-10" data-id="element-159">
                  Un día dejan de contestar los mensajes. O te mandan un{' '}
                  <span className="italic" data-id="element-160">
                    "me surgió algo, avisame cuando puedas"
                  </span>{' '}
                  que nunca termina en nada.
                </p>
                <p className="text-stone-700 mb-4 relative z-10" data-id="element-161">
                  El 67% de los alumnos de guitarra abandona antes de los 3
                  meses. No porque la guitarra sea difícil. Sino porque nadie
                  les mostró que estaban avanzando.
                </p>
                <div className="bg-white p-4 rounded-lg border border-stone-200 relative z-10 flex items-start gap-3" data-id="element-162">
                  <TrendingDown className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-163" />
                  <p className="text-stone-800 font-medium" data-id="element-164">
                    Si perdés 3 alumnos por año, son{' '}
                    <span className="text-red-600 font-bold" data-id="element-165">
                      $288.000 que se van con ellos
                    </span>
                    .
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-166">
              <div className="bg-amber-50 border border-amber-200 rounded-2xl p-8 shadow-sm relative overflow-hidden" data-id="element-167">
                <div className="absolute top-0 right-0 w-32 h-32 bg-amber-200/50 rounded-bl-full -z-0" data-id="element-168" />
                <h3 className="text-2xl font-black text-stone-900 mb-4 relative z-10 flex items-center gap-3" data-id="element-169">
                  <span className="bg-amber-500 text-white w-10 h-10 rounded-full flex items-center justify-center text-xl" data-id="element-170">
                    3
                  </span>
                  Los materiales que encontrás no son argentinos
                </h3>
                <p className="text-stone-700 mb-4 relative z-10" data-id="element-171">
                  Métodos españoles con canciones que acá no conoce nadie.
                  Métodos americanos con teoría que no tiene nada que ver con lo
                  que piden tus alumnos.
                </p>
                <p className="text-stone-800 font-bold mb-4 relative z-10" data-id="element-172">
                  Ninguno tiene una Chacarera. Ninguno tiene a Pappo. Ninguno
                  tiene a Gardel. Ninguno tiene a Conociendo Rusia.
                </p>
                <div className="bg-white p-4 rounded-lg border border-amber-100 relative z-10" data-id="element-173">
                  <p className="text-stone-700" data-id="element-174">
                    Entonces seguís preparando todo vos. Seguís improvisando a
                    las 11 de la noche del domingo.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* TRANSITION SECTION */}
      <section className="py-20 px-4 bg-stone-900 text-center relative" data-id="element-175">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20" data-id="element-176"></div>
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-177">
          <FadeIn data-id="element-178">
            <h2 className="text-3xl md:text-4xl font-black text-amber-500 mb-6 uppercase tracking-wider" data-id="element-179">
              La realidad es esta:
            </h2>
            <p className="text-2xl md:text-4xl text-white font-medium leading-tight" data-id="element-180">
              Los profesores de guitarra no se cansan de enseñar.
              <br data-id="element-181" />
              <br data-id="element-182" />
              <span className="font-black text-amber-400" data-id="element-183">
                Se cansan de tener que armar todo solos.
              </span>
            </p>
          </FadeIn>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-20 px-4 bg-amber-50" data-id="element-184">
        <div className="max-w-4xl mx-auto text-center" data-id="element-185">
          <FadeIn data-id="element-186">
            <p className="text-amber-600 font-bold tracking-widest uppercase mb-4" data-id="element-187">
              LA SOLUCIÓN
            </p>
            <h2 className="text-4xl md:text-5xl font-black text-stone-900 mb-8" data-id="element-188">
              MEGA KIT GUITARRA COMPLETA™ <br data-id="element-189" />
              <span className="text-amber-600" data-id="element-190">— EDICIÓN DOCENTE</span>
            </h2>
            <p className="text-xl text-stone-700 max-w-2xl mx-auto mb-6" data-id="element-191">
              Un sistema de trabajo creado específicamente para el docente de
              guitarra argentino.
            </p>
            <p className="text-xl text-stone-700 max-w-2xl mx-auto mb-8" data-id="element-192">
              Todo el material ya está organizado, estructurado y listo para
              aplicar en la próxima clase.
            </p>
            <div className="inline-block bg-white border-2 border-amber-200 rounded-xl px-8 py-4 shadow-md" data-id="element-193">
              <p className="text-2xl font-black text-stone-900" data-id="element-194">
                Solo tenés que descargar, imprimir y dar la clase.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* 6 TOMOS SECTION */}
      <section className="py-20 px-4 bg-white" data-id="element-195">
        <div className="max-w-6xl mx-auto" data-id="element-196">
          <FadeIn data-id="element-197">
            <div className="text-center mb-16" data-id="element-198">
              <h2 className="text-4xl md:text-5xl font-black text-stone-900 mb-4" data-id="element-199">
                6 TOMOS COMPLETOS
              </h2>
              <p className="text-xl text-stone-600" data-id="element-200">
                Un año entero de clases para cada perfil de alumno.
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-201">
            {[{
            title: 'TOMO 1: SEMILLERO ARGENTINO',
            subtitle: 'Kids 6 a 11 años',
            features: ['52 semanas de clases listas', '28 canciones argentinas con tablatura', 'Sistema de postura y técnica para niños', '9 HITOs de progreso con templates de WhatsApp para padres', 'Reportes mensuales imprimibles', 'Diplomas por nivel', 'El Gran Recital de Fin de Año'],
            songs: 'Muchachos, Manuelita, La Reina Batata, Himno Nacional y más.'
          }, {
            title: 'TOMO 2: FOGÓN NACIONAL',
            subtitle: 'Acústica Adultos',
            features: ['52 semanas de clases listas', '30 canciones argentinas', 'El Trío de Oro (SOL, DO, RE) y sus 500 canciones posibles', '7 acordes con cejilla incluida', '4 rasguidos fundamentales', 'Sistema del Asado Real de fin de año'],
            songs: 'Flaca, La Balsa, Seminare, De Música Ligera, Color Esperanza y más.'
          }, {
            title: 'TOMO 3: ELÉCTRICA ROCK & BLUES',
            subtitle: '',
            features: ['52 semanas de clases listas', '30 canciones del rock argentino', '5 solos icónicos transcriptos nota por nota', 'Guía de setup y amplificador', 'La Pentatónica en 5 posiciones', 'El Gran Show de fin de año'],
            songs: 'Pappo, Divididos, Los Redondos, La Renga, Spinetta.'
          }, {
            title: 'TOMO 4: NUESTRA TIERRA',
            subtitle: 'Folklore Argentino',
            features: ['52 semanas de clases listas', 'El único método de folklore argentino estructurado que existe', '30 canciones de todos los géneros', 'Zamba, Chacarera, Chamamé, Milonga y Gato', 'El punteo criollo de Yupanqui', 'La Gran Peña de fin de año'],
            songs: 'Zamba de mi Esperanza, Luna Tucumana, Alfonsina y el Mar y más.'
          }, {
            title: 'TOMO 5: ESQUINA TANGO & MILONGA',
            subtitle: '',
            features: ['52 semanas de clases listas', '30 tangos de Gardel a Piazzolla', 'El marcato y el rubato explicados desde cero', 'Acordes de 7ma y disminuidos', 'La Noche de Tango de fin de año'],
            songs: 'Mi Buenos Aires Querido, Por una Cabeza, Volver, Libertango y más.'
          }, {
            title: 'TOMO 6: LABORATORIO MODERNO',
            subtitle: '',
            features: ['52 semanas de clases listas', '30 canciones del indie, funk y pop actual', 'Acordes suspendidos y Add9', 'El Chop de Funk', 'Versiones acústicas de WOS y Trueno', 'Sistema de Looper en vivo', 'El Gran Streaming de fin de año'],
            songs: 'Conociendo Rusia, Babasónicos, Tan Biónica, WOS, Miranda! y más.'
          }].map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-202">
                <div className="bg-stone-50 border border-stone-200 rounded-2xl p-6 h-full flex flex-col hover:shadow-xl transition-shadow duration-300 hover:border-amber-300 group" data-id="element-203">
                  <div className="flex items-center gap-3 mb-4" data-id="element-204">
                    <span className="text-3xl group-hover:scale-110 transition-transform" data-id="element-205">
                      📘
                    </span>
                    <div data-id="element-206">
                      <h3 className="font-black text-stone-900 text-lg leading-tight" data-id="element-207">
                        {tomo.title}
                      </h3>
                      {tomo.subtitle && <p className="text-amber-600 font-bold text-sm" data-id="element-208">
                          {tomo.subtitle}
                        </p>}
                    </div>
                  </div>
                  <ul className="space-y-2 mb-6 flex-grow" data-id="element-209">
                    {tomo.features.map((feature, i) => <li key={i} className="flex items-start gap-2 text-sm text-stone-700" data-id="element-210">
                        <span className="text-amber-500 mt-1" data-id="element-211">•</span>
                        <span data-id="element-212">{feature}</span>
                      </li>)}
                  </ul>
                  <div className="bg-amber-50 p-3 rounded-lg border border-amber-100 mt-auto" data-id="element-213">
                    <p className="text-xs text-stone-600 italic font-medium" data-id="element-214">
                      <span className="font-bold text-stone-800 not-italic" data-id="element-215">
                        Canciones/Solos:
                      </span>{' '}
                      {tomo.songs}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* WHAT YOU GET SUMMARY */}
      <section className="py-16 px-4 bg-stone-900 text-white" data-id="element-216">
        <div className="max-w-3xl mx-auto" data-id="element-217">
          <FadeIn data-id="element-218">
            <h2 className="text-3xl md:text-4xl font-black text-center mb-10 text-amber-400" data-id="element-219">
              QUÉ TE LLEVÁS HOY
            </h2>
            <div className="bg-stone-800 rounded-2xl p-8 border border-stone-700 shadow-2xl" data-id="element-220">
              <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-221">
                MEGA KIT GUITARRA COMPLETA™ — EDICIÓN DOCENTE
              </h3>
              <ul className="space-y-4 mb-8" data-id="element-222">
                {['6 Tomos PDF completos', '178 canciones argentinas con tablatura', '52 semanas de clases diseñadas', 'Sistema de HITOs con criterios de aprobación', 'Templates de WhatsApp para padres y alumnos', 'Reportes mensuales imprimibles', 'Diplomas por nivel completado'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg" data-id="element-223">
                    <CheckCircle2 className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-224" />
                    <span data-id="element-225">{item}</span>
                  </li>)}
              </ul>
              <div className="text-center p-4 bg-stone-900 rounded-lg border border-stone-700" data-id="element-226">
                <p className="font-medium text-amber-200" data-id="element-227">
                  Listo para usar en clases presenciales, online, academias y
                  clases a domicilio.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-20 px-4 bg-amber-50" data-id="element-228">
        <div className="max-w-5xl mx-auto" data-id="element-229">
          <FadeIn data-id="element-230">
            <div className="text-center mb-12" data-id="element-231">
              <h2 className="text-4xl md:text-5xl font-black text-stone-900 mb-4 flex items-center justify-center gap-3" data-id="element-232">
                <Gift className="w-10 h-10 text-amber-600" data-id="element-233" /> BONOS INCLUIDOS
                HOY
              </h2>
              <div className="inline-block bg-red-600 text-white font-black px-6 py-2 rounded-full text-lg shadow-lg" data-id="element-234">
                GRATIS POR EL DÍA DE HOY
              </div>
            </div>
          </FadeIn>

          <div className="space-y-6 mb-16" data-id="element-235">
            {[{
            num: 1,
            title: 'SISTEMA DE RETENCIÓN DE ALUMNOS',
            value: '$15.000',
            desc: '52 templates de WhatsApp listos para copiar — 12 reportes mensuales imprimibles — 6 diplomas por nivel — Script del Aumento de Precio — Política de Faltas — Protocolo de Recuperación de Alumno',
            extra: 'Si retiene 1 solo alumno extra en el año, este bono ya pagó 5 veces el precio del kit.'
          }, {
            num: 2,
            title: 'PLANIFICADOR ANUAL DEL DOCENTE',
            value: '$12.000',
            desc: 'Planilla anual de 52 semanas organizada — Ficha de registro por alumno — Hoja de planificación semanal — Registro de cobros mensual — Semáforo de Riesgo de Abandono: identificá qué alumnos están en peligro antes de que se vayan'
          }, {
            num: 3,
            title: 'MÉTODO ANTI-ABANDONO PARA ADULTOS',
            value: '$10.000',
            desc: 'Los 7 motivos por los que los adultos abandonan y cómo prevenirlos — Script completo de la Primera Clase — Sistema de Victorias Rápidas — Protocolo de Recuperación — Guía de comunicación por rango etario'
          }, {
            num: 4,
            title: 'KIT DE CONTENIDO PARA INSTAGRAM',
            value: '$12.000',
            desc: '90 ideas de contenido para 3 meses organizadas semana a semana — 10 hooks para Reels — La Bio Perfecta del Docente — Guión del Reel de 30 segundos que convierte seguidores en consultas — Guía de precios 2024 por ciudad'
          }].map((bono, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-236">
                <div className="bg-white border-2 border-amber-200 rounded-2xl p-6 md:p-8 shadow-sm flex flex-col md:flex-row gap-6 items-start" data-id="element-237">
                  <div className="bg-amber-100 text-amber-700 w-16 h-16 rounded-2xl flex items-center justify-center text-3xl flex-shrink-0 font-black" data-id="element-238">
                    🎁
                  </div>
                  <div className="flex-grow" data-id="element-239">
                    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 mb-3" data-id="element-240">
                      <h3 className="text-xl font-black text-stone-900" data-id="element-241">
                        BONO {bono.num}: {bono.title}
                      </h3>
                      <div className="flex items-center gap-2 text-sm font-bold" data-id="element-242">
                        <span className="line-through text-stone-400" data-id="element-243">
                          Valor: {bono.value}
                        </span>
                        <span className="bg-green-100 text-green-700 px-2 py-1 rounded uppercase tracking-wider" data-id="element-244">
                          — GRATIS HOY
                        </span>
                      </div>
                    </div>
                    <p className="text-stone-700 mb-3 leading-relaxed" data-id="element-245">
                      {bono.desc}
                    </p>
                    {bono.extra && <p className="text-sm font-medium text-amber-700 italic" data-id="element-246">
                        {bono.extra}
                      </p>}
                  </div>
                </div>
              </FadeIn>)}

            {/* Special Bono 5 */}
            <FadeIn delay={0.4} data-id="element-247">
              <div className="bg-stone-900 border-2 border-red-500 rounded-2xl p-6 md:p-8 shadow-2xl relative overflow-hidden mt-8" data-id="element-248">
                <div className="absolute top-4 right-4 animate-pulse" data-id="element-249">
                  <AlertTriangle className="w-8 h-8 text-red-500" data-id="element-250" />
                </div>
                <div className="flex flex-col md:flex-row gap-6 items-start relative z-10" data-id="element-251">
                  <div className="bg-red-500/20 text-red-500 w-16 h-16 rounded-2xl flex items-center justify-center text-3xl flex-shrink-0 font-black border border-red-500/30" data-id="element-252">
                    🎁
                  </div>
                  <div className="flex-grow" data-id="element-253">
                    <div className="inline-block bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-254">
                      Solo primeros 50 compradores
                    </div>
                    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 mb-3" data-id="element-255">
                      <h3 className="text-xl md:text-2xl font-black text-white" data-id="element-256">
                        BONO 5: GUÍA DE PRECIOS Y NEGOCIO PARA DOCENTES
                      </h3>
                    </div>
                    <div className="flex items-center gap-2 text-sm font-bold mb-4" data-id="element-257">
                      <span className="line-through text-stone-500" data-id="element-258">
                        Valor: $20.000
                      </span>
                      <span className="text-red-400 uppercase tracking-wider" data-id="element-259">
                        — GRATIS SOLO PARA LOS PRIMEROS 50
                      </span>
                    </div>
                    <p className="text-stone-300 mb-4 leading-relaxed" data-id="element-260">
                      Precios de referencia por ciudad 2024 — Calculadora de
                      ingresos — Protocolo del aumento de precio con scripts —
                      El Contrato Mínimo del Docente — Guía impositiva básica —
                      Plan de Negocio de 12 meses — Sistema de Referidos
                    </p>
                    <div className="bg-red-950/50 border border-red-900/50 p-3 rounded-lg flex items-start gap-3" data-id="element-261">
                      <AlertTriangle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-262" />
                      <p className="text-red-200 text-sm font-medium" data-id="element-263">
                        <span className="font-bold text-white" data-id="element-264">
                          ⚠️ Este bono desaparece cuando se llenen los 50 cupos.
                        </span>{' '}
                        Sin segunda fecha.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>

          <FadeIn data-id="element-265">
            <div className="text-center mt-12" data-id="element-266">
              <button onClick={scrollToCompra} className="w-full md:w-auto bg-green-600 hover:bg-green-500 text-white text-xl md:text-2xl font-black py-5 px-10 rounded-full shadow-[0_0_40px_rgba(22,163,74,0.4)] hover:shadow-[0_0_60px_rgba(22,163,74,0.6)] transition-all transform hover:-translate-y-1 animate-pulse-glow flex items-center justify-center gap-3 mx-auto" data-id="element-267">
                SÍ, QUIERO EL MEGA KIT GUITARRA COMPLETA{' '}
                <ArrowRight className="w-6 h-6" data-id="element-268" />
              </button>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section className="py-20 px-4 bg-white" data-id="element-269">
        <div className="max-w-5xl mx-auto" data-id="element-270">
          <FadeIn data-id="element-271">
            <h2 className="text-3xl md:text-4xl font-black text-center text-stone-900 mb-12" data-id="element-272">
              LO QUE DICEN DOCENTES QUE YA LO USAN
            </h2>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-273">
            {[{
            quote: 'Llevo 12 años dando clases y siempre preparé mis propias planificaciones. Con este kit armé todo el año en un fin de semana. Nunca más voy a volver a improvisar una clase.',
            name: 'Martín G.',
            role: 'Docente de Guitarra, Buenos Aires'
          }, {
            quote: 'El Tomo 4 de Folklore es oro puro. Mis alumnos me pedían zambas y chacareras y yo no tenía material organizado. Ahora tengo un año entero de folklore argentino listo para dar.',
            name: 'Valeria R.',
            role: 'Profesora de Guitarra, Tucumán'
          }, {
            quote: 'Los templates de WhatsApp solos ya valen el precio del kit. Los padres empezaron a ver el progreso de sus hijos y ningún alumno abandonó este año.',
            name: 'Diego F.',
            role: 'Docente Independiente, Córdoba'
          }, {
            quote: 'Siempre usé métodos europeos porque no existía nada argentino organizado. Este kit cambió completamente la forma en que doy clases.',
            name: 'Luciana M.',
            role: 'Docente de Guitarra, Rosario'
          }, {
            quote: 'Desde que uso el kit, mis alumnos están más motivados y yo tengo tiempo para crecer mi academia. Lo mejor que invertí este año.',
            name: 'Sebastián P.',
            role: 'Docente de Guitarra, Mendoza'
          }].map((testimonial, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-274">
                <div className={`bg-stone-50 border border-stone-200 rounded-2xl p-8 h-full flex flex-col ${index === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-275">
                  <div className="flex gap-1 mb-4" data-id="element-276">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-277" />)}
                  </div>
                  <p className="text-stone-700 italic mb-6 flex-grow text-lg" data-id="element-278">
                    "{testimonial.quote}"
                  </p>
                  <div data-id="element-279">
                    <p className="font-black text-stone-900" data-id="element-280">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-281">{testimonial.role}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* COUNTDOWN TIMER SECTION */}
      <section className="py-16 px-4 bg-stone-900 text-white border-y-4 border-red-600" data-id="element-282">
        <div className="max-w-3xl mx-auto text-center" data-id="element-283">
          <FadeIn data-id="element-284">
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-285">
              <Clock className="w-8 h-8 text-amber-400 animate-pulse" data-id="element-286" />
              <h2 className="text-3xl font-black uppercase tracking-wider" data-id="element-287">
                ESTA OFERTA EXPIRA EN
              </h2>
            </div>

            <div className="mb-8" data-id="element-288">
              <CountdownTimer data-id="element-289" />
            </div>

            <p className="text-xl md:text-2xl text-red-400 font-bold max-w-2xl mx-auto" data-id="element-290">
              Cuando el contador llegue a cero el precio sube a $34.990 y el
              Bono 5 desaparece para siempre.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* PRICING SECTION */}
      <PricingSection data-id="element-291" />

      {/* GUARANTEE SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-292">
        <div className="max-w-3xl mx-auto text-center" data-id="element-293">
          <FadeIn data-id="element-294">
            <ShieldCheck className="w-20 h-20 text-amber-500 mx-auto mb-6" data-id="element-295" />
            <h2 className="text-3xl font-black text-stone-900 mb-6" data-id="element-296">
              GARANTÍA TOTAL 7 DÍAS
            </h2>
            <p className="text-lg text-stone-600 mb-6" data-id="element-297">
              Probá todo el material durante una semana.
            </p>
            <p className="text-lg text-stone-600 mb-8" data-id="element-298">
              Si no sentís más orden en tus clases, menos tiempo preparando
              material y más seguridad frente a cada alumno, te devolvemos el
              100% del dinero.
            </p>
            <p className="text-xl font-black text-stone-900 bg-amber-50 inline-block px-6 py-3 rounded-lg border border-amber-200" data-id="element-299">
              Sin preguntas. Sin formularios. Un email y listo.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-stone-950 text-stone-400 py-12 px-4 text-center text-sm" data-id="element-300">
        <div className="max-w-4xl mx-auto" data-id="element-301">
          <p className="mb-4" data-id="element-302">
            © 2024 Mega Kit Guitarra Completa. Todos los derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-303">
            <a href="#" className="hover:text-white transition-colors" data-id="element-304">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-305">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-306">
              Contacto
            </a>
          </div>
        </div>
      </footer>
    </div>;
}